import { UserRole } from "@excel-center/shared";
import { lazy } from "react";
import type { RouteObject } from "react-router";
import { ProtectedRoute } from "@/src/auth/components/protected-route";
import { STAFFS_ROUTES } from "@/src/staffs/constants/staffs-routes.constants";

const StaffsListPage = lazy(() => import("@/src/staffs/pages/staffs-list.page"));

/**
 * Staff Management routes. Admins and super admins can invite, edit and
 * revoke staff; RLS plus a profiles guard trigger prevent admins from
 * touching super_admin accounts or minting new super admins.
 */
export const staffsRoutes: RouteObject[] = [
	{
		element: <ProtectedRoute requiredRole={[UserRole.ADMIN, UserRole.SUPER_ADMIN]} />,
		children: [{ path: STAFFS_ROUTES.staffs, element: <StaffsListPage /> }],
	},
];
